module.exports = __webpack_public_path__ + "img/hr_venue_logo.0481f160.svg";